import { Component, input, ChangeDetectionStrategy, ViewEncapsulation, computed } from "@angular/core";
import { CommonModule } from "@angular/common";
import { cn } from "../utils/utils";

@Component({
  selector: "agent-chat-user-message-renderer",
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    "[class]": "computedClass()",
  },
  template: `{{ content() }}`,
})
export class AgentChatUserMessageRenderer {
  readonly content = input<string>("");

  readonly inputClass = input<string | undefined>();

  readonly computedClass = computed(() => cn("achat-user-msg__content", this.inputClass()));
}
